import { servicesTree, ServiceNode } from "../services/servicesConfig";

export interface SearchItem {
  id: string;
  label: string;
  path: string[];
  route: string;
}

const routeMap: Record<string, string> = {
  // SOCIAL
  youtube: "/social",
  instagram: "/social",
  facebook: "/social",
  social: "/social",

  // WEBSITE
  website: "/dashboard",
  landingPages: "/dashboard",
  businessWebsite: "/dashboard",
  seo: "/dashboard",

  // AUTOMATION
  email: "/dashboard",
  campaigns: "/dashboard",
  templates: "/dashboard",
  analytics: "/dashboard",
  whatsapp: "/dashboard",
  n8n: "/dashboard",

  // TOOLS
  tagExtractor: "/youtube",
  emailValidator: "/dashboard",
  smsSender: "/dashboard",
};

const flattenTree = (
  nodes: ServiceNode[],
  parentPath: string[] = []
): SearchItem[] => {
  let items: SearchItem[] = [];

  nodes.forEach((node) => {
    const currentPath = [...parentPath, node.label];

    items.push({
      id: node.id,
      label: node.label,
      path: currentPath,
      route: routeMap[node.id] || "/dashboard",
    });

    if (node.children) {
      items = items.concat(flattenTree(node.children, currentPath));
    }
  });

  return items;
};

export const searchIndex = flattenTree(servicesTree);
